import gql from 'graphql-tag';

export default ({ variables }) => ({
  query: gql`
    query productDetails(
      $search: String = ""
      $filter: ProductAttributeFilterInput
      $pageSize: Int = 10
      $currentPage: Int = 1
      $sort: ProductAttributeSortInput
    ) {
      products(
        search: $search
        filter: $filter
        sort: $sort
        pageSize: $pageSize
        currentPage: $currentPage
      ) {
        items {
          uid
          sku
          name
          stock_status
          only_x_left_in_stock
          custom_attributes {
            attribute_metadata {
              code
              label
            }
          }
          thumbnail {
            url
            position
            disabled
            label
          }
          url_key
          url_rewrites {
            url
          }
          categories {
            uid
            name
            url_suffix
            url_path
            breadcrumbs {
              category_name
              category_url_path
            }
          }
          rating_summary
          review_count
          reviews {
            items {
              average_rating
              ratings_breakdown {
                name
                value
              }
            }
          }
          small_image {
            url
            position
            disabled
            label
          }
          image {
            url
            position
            disabled
            label
          }
          media_gallery {
            url
            position
            disabled
            label
          }
          thumbnail {
            url
            position
            disabled
            label
          }
          url_key
          url_rewrites {
            url
          }
          meta_description
          meta_keyword
          meta_title
          description {
            html
          }
          short_description {
            html
          }
          options_container
          special_to_date
          standards 
          grade
          diameter
          diameter_tolerance 
          tensile_strength_tolerance 
          surface_condition 
          wire_weight
          coating_weight
          package
          package_coil_model
          package_with_and_without_coil_model
          package_spool_model
          package_spoolless_coil_model
          packaging_dimensions 
          related_products {
            uid
            __typename
            sku
            name
            stock_status
            only_x_left_in_stock
            rating_summary
            standards 
            grade
            diameter
            diameter_tolerance 
            tensile_strength_tolerance 
            surface_condition 
            wire_weight
            package_coil_model
            package_with_and_without_coil_model
            package_spool_model
            package_spoolless_coil_model
            package
            packaging_dimensions 
            thumbnail {
              url
              position
              disabled
              label
            }
          url_key
          url_rewrites {
            url
          }
          price_range {
            maximum_price {
              final_price {
                currency
                value
              }
              regular_price {
                currency
                value
              }
            }
            minimum_price {
              final_price {
                currency
                value
              }
              regular_price {
                currency
                value
              }
            }
          }
          
        }
          ... on ConfigurableProduct {
            configurable_options {
              attribute_code
              attribute_uid
              label
              position
              uid
              use_default
              values {
                label
                swatch_data {
                  value
                }
                uid
              }
            }
          }
          ... on DownloadableProduct {
            downloadable_product_samples {
              sample_url
              title
            }
            downloadable_product_links {
              id
              price
              title
              uid
            }
          }
          ... on VirtualProduct {
            gift_message_available
            product_links {
              link_type
              linked_product_sku
              linked_product_type
              position
              sku
            }
          }
          ... on GroupedProduct {
            items {
              position
              qty
              product {
                uid
                sku
                name
                stock_status
                only_x_left_in_stock
                price_range {
                  maximum_price {
                    final_price {
                      currency
                      value
                    }
                    regular_price {
                      currency
                      value
                    }
                  }
                  minimum_price {
                    final_price {
                      currency
                      value
                    }
                    regular_price {
                      currency
                      value
                    }
                  }
                }
                thumbnail {
                  url
                  position
                  disabled
                  label
                }
              }
            }
          }
          ... on CustomizableProductInterface {
            options {
              uid
              title
              required
              sort_order
              option_id
              ... on CustomizableFieldOption {
                field: value {
                  uid
                  sku
                  price
                  price_type
                  max_characters
                }
              }
              ... on CustomizableAreaOption {
                area: value {
                  uid
                  sku
                  price
                  price_type
                  max_characters
                }
              }
              ... on CustomizableDropDownOption {
                dropDown: value {
                  option_type_id
                  uid
                  sku
                  title
                  price
                  price_type
                  sort_order
                }
              }
              ... on CustomizableRadioOption {
                radio: value {
                  option_type_id
                  uid
                  sku
                  title
                  price
                  price_type
                  sort_order
                }
              }
              ... on CustomizableCheckboxOption {
                checkbox: value {
                  option_type_id
                  uid
                  sku
                  title
                  price
                  price_type
                  sort_order
                }
              }
              ... on CustomizableMultipleOption {
                multiple: value {
                  option_type_id
                  uid
                  sku
                  title
                  price
                  price_type
                  sort_order
                }
              }
              ... on CustomizableDateOption {
                date: value {
                  uid
                  type
                  sku
                  price
                  price_type
                }
              }
            }
          }
        }
      }
    }
  `,
  variables,    
});